var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99023 7.29375L3.86523 6.30625C3.3878 6.19375 3.05551 5.82812 3.05551 5.42188C3.05551 4.9125 3.55967 4.5 4.18224 4.5H6.71454C7.18051 4.5 7.63884 4.61562 8.02079 4.82812C8.25377 4.95625 8.56697 4.925 8.76558 4.76562L10.0947 3.70312C10.3659 3.4875 10.3277 3.12812 10.026 2.9375C9.09023 2.3375 7.92148 2.00312 6.72217 2V0.5C6.72217 0.225 6.44717 0 6.11106 0H4.88884C4.55273 0 4.27773 0.225 4.27773 0.5V2H4.18224C1.74926 2 -0.206299 3.70938 0.0190485 5.7375C0.179465 7.17813 1.52391 8.35 3.21974 8.75625L7.13467 9.69375C7.6121 9.80938 7.9444 10.1719 7.9444 10.5781C7.9444 11.0875 7.44023 11.5 6.81766 11.5H4.28537C3.8194 11.5 3.36106 11.3844 2.97912 11.1719C2.74613 11.0437 2.43294 11.075 2.23433 11.2344L0.90516 12.2969C0.633979 12.5125 0.672174 12.8719 0.97391 13.0625C1.90967 13.6625 3.07842 13.9969 4.27773 14V15.5C4.27773 15.775 4.55273 16 4.88884 16H6.11106C6.44717 16 6.72217 15.775 6.72217 15.5V13.9937C8.50204 13.9656 10.1711 13.1 10.7593 11.7219C11.5805 9.79688 10.2017 7.82187 7.99023 7.29375Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.735d81c7.svg";
export { ForwardRef as ReactComponent };